import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
export const RuleTextSearchIcon = (props) => (<SvgIcon viewBox="0 0 16 16" sx={{ fill: 'transparent' }} {...props}>
    <path d="M14 4H2M6.66667 8H2M6.66667 12H2M14.0001 12.6667L12.7334 11.4001M13.3333 10C13.3333 11.1046 12.4379 12 11.3333 12C10.2288 12 9.33333 11.1046 9.33333 10C9.33333 8.89543 10.2288 8 11.3333 8C12.4379 8 13.3333 8.89543 13.3333 10Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </SvgIcon>);
export default RuleTextSearchIcon;
